import { create } from 'apisauce';
import { getAuthToken } from 'utils/cookies';

const token = getAuthToken();

export const getCalendarEvents = async ({ start, end, permissions }) => {
  const api = create({
    baseURL: `${process.env.REACT_APP_AP_URL}/api/calendar`,
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Authorization': `Bearer ${token}`,
    },
  });

  const response = await api.get('', {
    start,
    end,
    ...(permissions ? { permissions: true } : {}),
  });

  const { ok, problem } = response;
  if (!ok) {
    return { error: problem };
  }
  return response.data;
};

export const getExternalCalendarEvents = async ({ start, end, permissions }) => {
  const api = create({
    baseURL: `${process.env.REACT_APP_AP_URL}/api/external-calendar`,
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Authorization': `Bearer ${token}`,
    },
  });

  const response = await api.get('', {
    start,
    end,
    ...(permissions ? { permissions: true } : {}),
  });

  const { ok, problem } = response;
  if (!ok) {
    return { error: problem };
  }
  return response.data;
};

export const fetchRemainingCalendarEvents = async ({ calendarId, nextCursor, dateStart, dateEnd }) => {
  const api = create({
    baseURL: `${process.env.REACT_APP_AP_URL}/api/calendar`,
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Authorization': `Bearer ${token}`,
    },
  });

  const response = await api.post(
    '/remaining-events',
    {
      calendar_id: calendarId,
      next_cursor: nextCursor,
      date_start: dateStart,
      date_end: dateEnd,
    });
  const { ok, problem } = response;

  if (!ok) {
    return { error: problem };
  }

  return response.data;
};

export const getEventInfo = async ({ urlSlug, type }) => {
  const api = create({
    baseURL: `${process.env.REACT_APP_AP_URL}/${type}/${urlSlug}/json`,
    headers: {
      'content-type': 'application/json',
      'x-authorization': `api-key ${process.env.REACT_APP_WEBAPP_API_KEY}`,
    },
  });

  const response = await api.get('', {});

  const { ok, problem } = response;
  if (!ok) {
    return { error: problem };
  }
  return response.data;
};

export const getGuestRSVP = async ({ name, wedding_id }) => {
  const api = create({
    baseURL: `${process.env.REACT_APP_AP_URL}/webhook/nodejs/wedding/guest_rsvp/${wedding_id}`,
    headers: {
      'content-type': 'application/json',
      'x-authorization': `api-key ${process.env.REACT_APP_WEBAPP_API_KEY}`,
    },
  });

  const response = await api.get('', { name });
  if (response.ok) {
    return {
      data: response.data,
      error: null,
    };
  }
  return {
    data: [],
    error: response.originalError,
  };
};

export const addCalendarEvent = async ({ weddingId, eventData }) => {
  const api = create({
    baseURL: `${process.env.REACT_APP_AP_URL}/api/wedding/${weddingId}/calendar/events`,
    headers: {
      'Content-Type': 'application/json',
      'X-Authorization': `api-key ${process.env.REACT_APP_WEBAPP_API_KEY}`,
      'X-Requested-With': 'XMLHttpRequest',
    },
  });

  return api.post('', eventData);
};

export const updateCalendarEvent = async ({ weddingId, eventId, eventData }) => {
  const api = create({
    baseURL: `${process.env.REACT_APP_AP_URL}/api/wedding/${weddingId}/calendar/events/${eventId}`,
    headers: {
      'Content-Type': 'application/json',
      'X-Authorization': `api-key ${process.env.REACT_APP_WEBAPP_API_KEY}`,
      'X-Requested-With': 'XMLHttpRequest',
    },
  });

  return api.put('', eventData);
};

export const deleteCalendarEvent = async ({ weddingId, eventId }) => {
  const api = create({
    baseURL: `${process.env.REACT_APP_AP_URL}`,
    headers: {
      'Content-Type': 'application/json',
      'X-Authorization': `api-key ${process.env.REACT_APP_WEBAPP_API_KEY}`,
      'X-Requested-With': 'XMLHttpRequest',
    },
  });

  return api.delete(`/api/wedding/${weddingId}/calendar/events/${eventId}`);
};

export const updateWeddingChecklistItem = async ({ weddingId, taskId, itemData }) => {
  const api = create({
    baseURL: `${process.env.REACT_APP_AP_URL}/api/wedding/${weddingId}/checklist/items/${taskId}`,
    headers: {
      'Content-Type': 'application/json',
      'X-Authorization': `api-key ${process.env.REACT_APP_WEBAPP_API_KEY}`,
      'X-Requested-With': 'XMLHttpRequest',
    },
  });

  return api.put('', itemData);
};

export const updateLeadChecklistItem = async ({ orgId, leadId, taskId, itemData }) => {
  const api = create({
    baseURL: `${process.env.REACT_APP_AP_URL}/api/organization/${orgId}/leads/${leadId}/checklist/items/${taskId}`,
    headers: {
      'Content-Type': 'application/json',
      'X-Authorization': `api-key ${process.env.REACT_APP_WEBAPP_API_KEY}`,
      'X-Requested-With': 'XMLHttpRequest',
    },
  });

  return api.put('', itemData);
};

export const updateGeneralChecklistItem = async ({ taskId, itemData }) => {
  const api = create({
    baseURL: `${process.env.REACT_APP_AP_URL}/api/tasks/${taskId}`,
    headers: {
      'Content-Type': 'application/json',
      'X-Authorization': `api-key ${process.env.REACT_APP_WEBAPP_API_KEY}`,
      'X-Requested-With': 'XMLHttpRequest',
    },
  });

  return api.put('', itemData);
};
